import { 
  API_BASE_APPOINTMENT_URL,
  API_APPOINTMENTS_BASE,
  API_APPOINTMENTS_BY_APPOINTMENT_ID,
  API_APPOINTMENTS_CHECK_DESPACHO,
  API_APPOINTMENTS_BY_PRODUCT,
  API_APPOINTMENTS_BY_DESPACHO,
  API_APPOINTMENTS_DOCTOR,
  API_APPOINTMENTS_PATIENT,
  API_APPOINTMENTS_ACCEPT,
  API_APPOINTMENTS_STATUS,
  API_APPOINTMENTS_CHECKIN,
  API_APPOINTMENTS_START_CONSULTATION,
  API_APPOINTMENTS_COMPLETE,
  API_APPOINTMENTS_WALK_IN,
  API_APPOINTMENTS_RESCHEDULE,
  API_APPOINTMENTS_CANCEL,
  API_APPOINTMENTS_CONFIRM,
  API_APPOINTMENTS_NO_SHOW,
  API_APPOINTMENTS_PAYMENT,
  API_APPOINTMENTS_REFUND,
  API_APPOINTMENTS_TODAY,
  API_APPOINTMENTS_PENDING,
  API_APPOINTMENTS_WAITING_QUEUE,
  API_APPOINTMENTS_WALK_IN_LIST,
  API_APPOINTMENTS_CANCELLED,
  API_APPOINTMENTS_PAYMENT_STATS,
  buildQueryString
} from '../../../helpers/urlHelper';

class AppointmentService {
  
  // ========================================================================
  // 🔧 CONFIGURATION & HEADERS
  // ========================================================================
  
  constructor() {
    this.baseUrl = API_BASE_APPOINTMENT_URL;
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
  }

  // ========================================================================
  // 🔧 URL BUILDERS - COINCIDEN CON LAS RUTAS DEL BACKEND
  // ========================================================================

  buildUrl(path = '', params = {}) {
    const url = `${this.baseUrl}${path}`;
    const queryString = buildQueryString(params);
    return `${url}${queryString}`;
  }

  // 1. RUTAS BASE
  getAppointmentsUrl(params = {}) { 
    return this.buildUrl(API_APPOINTMENTS_BASE, params); 
  }
  
  getAppointmentByIdUrl(id, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}`, params); 
  }
  
  getAppointmentByAppointmentIdUrl(appointmentId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_BY_APPOINTMENT_ID}/${appointmentId}`, params); 
  }

  // ✅ 2. RUTAS DE VERIFICACIÓN/UTILIDADES
  getCheckDespachoAvailabilityUrl(params = {}) {
    return this.buildUrl(API_APPOINTMENTS_CHECK_DESPACHO, params);
  }

  // ✅ 3. RUTAS POR PRODUCTOS
  getAppointmentsByProductUrl(productoCitaId, params = {}) {
    return this.buildUrl(`${API_APPOINTMENTS_BY_PRODUCT}/${productoCitaId}`, params);
  }

  getAppointmentsByDespachoUrl(despachoId, params = {}) {
    return this.buildUrl(`${API_APPOINTMENTS_BY_DESPACHO}/${despachoId}`, params);
  }

  // 4. RUTAS ESPECÍFICAS PARA DOCTORES
  getDoctorTodayAppointmentsUrl(doctorId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_TODAY}`, params); 
  }
  
  getDoctorPendingAppointmentsUrl(doctorId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_PENDING}`, params); 
  }
  
  getDoctorWaitingQueueUrl(doctorId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_WAITING_QUEUE}`, params); 
  }

  getDoctorWalkInAppointmentsUrl(doctorId, params = {}) {
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_WALK_IN_LIST}`, params);
  }

  getDoctorCancelledAppointmentsUrl(doctorId, params = {}) {
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_CANCELLED}`, params);
  }

  getDoctorPaymentStatsUrl(doctorId, params = {}) {
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}${API_APPOINTMENTS_PAYMENT_STATS}`, params);
  }

  getDoctorAppointmentsUrl(doctorId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_DOCTOR}/${doctorId}`, params); 
  }

  // 5. RUTAS ESPECÍFICAS PARA PACIENTES
  getPatientAppointmentsUrl(patientId, params = {}) { 
    return this.buildUrl(`${API_APPOINTMENTS_PATIENT}/${patientId}`, params); 
  }

  // 6. RUTAS DE ACCIONES ESPECÍFICAS (ORDEN CRÍTICO)
  getAcceptAppointmentUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_ACCEPT}`); 
  }
  
  getUpdateStatusUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_STATUS}`); 
  }
  
  getCheckInUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_CHECKIN}`); 
  }
  
  getStartConsultationUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_START_CONSULTATION}`); 
  }
  
  getCompleteConsultationUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_COMPLETE}`); 
  }

  getMarkAsWalkInUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_WALK_IN}`); 
  }
  
  getRescheduleAppointmentUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_RESCHEDULE}`); 
  }
  
  getCancelAppointmentUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_CANCEL}`); 
  }
  
  getConfirmAppointmentUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_CONFIRM}`); 
  }
  
  getMarkAsNoShowUrl(id) { 
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_NO_SHOW}`); 
  }

  // ✅ RUTAS DE PAGOS
  getRecordPaymentUrl(id) {
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_PAYMENT}`);
  }

  getRefundPaymentUrl(id) {
    return this.buildUrl(`${API_APPOINTMENTS_BASE}/${id}${API_APPOINTMENTS_REFUND}`);
  }

  // ========================================================================
  // 🔧 UTILITY METHODS
  // ========================================================================

  async handleResponse(response) {
    try {
      const contentType = response.headers.get('content-type');
      
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('❌ Non-JSON response received:', {
          status: response.status,
          statusText: response.statusText,
          contentType,
          body: text.substring(0, 200)
        });
        throw new Error(`Expected JSON but received ${contentType || 'unknown content type'}. Status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || `HTTP Error: ${response.status} ${response.statusText}`);
      }
      
      return data;
    } catch (error) {
      if (error instanceof SyntaxError) {
        throw new Error(`Invalid JSON response: ${response.status} ${response.statusText}`);
      }
      throw error;
    }
  }

  async makeApiCall(url, options = {}) {
    try {
      console.log(`🌐 ${options.method || 'GET'} → ${url}`);
      
      if (options.body) {
        console.log('📤 Request Body:', JSON.parse(options.body));
      }

      const response = await fetch(url, {
        headers: this.getHeaders(),
        ...options
      });

      console.log(`📥 Response: ${response.status} ${response.statusText}`);
      
      const result = await this.handleResponse(response);
      console.log('✅ Success:', result.success !== false);
      
      return result;
      
    } catch (error) {
      console.error('❌ API Call Failed:', {
        url,
        method: options.method || 'GET',
        error: error.message
      });
      throw error;
    }
  }

  // ========================================================================
  // 📋 CRUD OPERATIONS
  // ========================================================================

  async createAppointment(data) {
    const url = this.getAppointmentsUrl();
    return await this.makeApiCall(url, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getAllAppointments(params = {}) {
    const url = this.getAppointmentsUrl(params);
    return await this.makeApiCall(url);
  }

  async getAppointmentById(id) {
    const url = this.getAppointmentByIdUrl(id);
    return await this.makeApiCall(url);
  }

  async getAppointmentByAppointmentId(appointmentId) {
    const url = this.getAppointmentByAppointmentIdUrl(appointmentId);
    return await this.makeApiCall(url);
  }

  async updateAppointment(id, data) {
    const url = this.getAppointmentByIdUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async deleteAppointment(id) {
    const url = this.getAppointmentByIdUrl(id);
    return await this.makeApiCall(url, {
      method: 'DELETE'
    });
  }

  // ========================================================================
  // 📊 STATUS MANAGEMENT
  // ========================================================================

  async acceptAppointment(id) {
    const url = this.getAcceptAppointmentUrl(id);
    return await this.makeApiCall(url, { method: 'PUT' });
  }

  async updateAppointmentStatus(id, status, notes = null) {
    const url = this.getUpdateStatusUrl(id);
    
    const requestBody = { status };
    if (notes) requestBody.notes = notes;
    
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(requestBody)
    });
  }

  async checkinPatient(id) {
    console.log('🚪 Starting patient check-in for ID:', id);
    const url = this.getCheckInUrl(id);
    return await this.makeApiCall(url, { method: 'PUT' });
  }

  async startConsultation(id) {
    const url = this.getStartConsultationUrl(id);
    return await this.makeApiCall(url, { method: 'PUT' });
  }

  async completeConsultation(id, notes = null) {
    const url = this.getCompleteConsultationUrl(id);
    
    const requestBody = {};
    if (notes) requestBody.notes = notes;
    
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(requestBody)
    });
  }

  // ========================================================================
  // 🎯 SPECIFIC ACTIONS
  // ========================================================================

  async markAsWalkIn(id, data = {}) {
    console.log('🚶 Marking as walk-in:', { id, data });
    const url = this.getMarkAsWalkInUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async rescheduleAppointment(id, data) {
    const url = this.getRescheduleAppointmentUrl(id);
    console.log('🔄 Rescheduling:', { id, data, url });
    
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async cancelAppointment(id, data = {}) {
    const url = this.getCancelAppointmentUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async confirmAppointment(id, data = {}) {
    const url = this.getConfirmAppointmentUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async markAsNoShow(id, data = {}) {
    const url = this.getMarkAsNoShowUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  // ========================================================================
  // 💳 PAYMENT OPERATIONS
  // ========================================================================

  async recordPayment(id, amount) {
    const url = this.getRecordPaymentUrl(id);
    return await this.makeApiCall(url, {
      method: 'PUT',
      body: JSON.stringify({ amount })
    });
  }

  async refundPayment(id) {
    const url = this.getRefundPaymentUrl(id);
    return await this.makeApiCall(url, { method: 'PUT' });
  }

  async getPaymentStats(doctorId, startDate = null, endDate = null) {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const url = this.getDoctorPaymentStatsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  // ========================================================================
  // 👨‍⚕️ DOCTOR OPERATIONS
  // ========================================================================

  async getDoctorAppointments(doctorId, params = {}) {
    const url = this.getDoctorAppointmentsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  async getDoctorTodayAppointments(doctorId, params = {}) {
    const url = this.getDoctorTodayAppointmentsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  async getDoctorPendingAppointments(doctorId, params = {}) {
    const url = this.getDoctorPendingAppointmentsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  async getDoctorWaitingQueue(doctorId, params = {}) {
    const url = this.getDoctorWaitingQueueUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  async getDoctorWalkInAppointments(doctorId, params = {}) {
    const url = this.getDoctorWalkInAppointmentsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  async getDoctorCancelledAppointments(doctorId, params = {}) {
    const url = this.getDoctorCancelledAppointmentsUrl(doctorId, params);
    return await this.makeApiCall(url);
  }

  // ========================================================================
  // 👤 PATIENT OPERATIONS
  // ========================================================================

  async getPatientAppointments(patientId, params = {}) {
    const url = this.getPatientAppointmentsUrl(patientId, params);
    return await this.makeApiCall(url);
  }

  // ========================================================================
  // 🏥 PRODUCT/DESPACHO OPERATIONS
  // ========================================================================

  async getAppointmentsByProduct(productoCitaId, date = null) {
    const params = {};
    if (date) params.date = date;
    
    const url = this.getAppointmentsByProductUrl(productoCitaId, params);
    return await this.makeApiCall(url);
  }

  async getAppointmentsByDespacho(despachoId, date = null) {
    const params = {};
    if (date) params.date = date;
    
    const url = this.getAppointmentsByDespachoUrl(despachoId, params);
    return await this.makeApiCall(url);
  }

  async checkDespachoAvailability(despachoId, date, startTime, endTime, excludeAppointmentId = null) {
    const params = {
      despachoId,
      date,
      startTime,
      endTime
    };
    
    if (excludeAppointmentId) {
      params.excludeAppointmentId = excludeAppointmentId;
    }
    
    const url = this.getCheckDespachoAvailabilityUrl(params);
    return await this.makeApiCall(url);
  }

  // ========================================================================
  // 🔍 SEARCH & UTILITY METHODS
  // ========================================================================

  async searchAppointments(searchCriteria) {
    return await this.getAllAppointments(searchCriteria);
  }

  async getAppointmentsByDateRange(startDate, endDate, additionalParams = {}) {
    const params = { startDate, endDate, ...additionalParams };
    return await this.getAllAppointments(params);
  }

  async getAppointmentsByStatus(status, additionalParams = {}) {
    const params = { status, ...additionalParams };
    return await this.getAllAppointments(params);
  }

  // ========================================================================
  // 🔄 BATCH OPERATIONS
  // ========================================================================

  async getAppointmentsByIds(ids) {
    const promises = ids.map(id => this.getAppointmentById(id));
    const results = await Promise.allSettled(promises);
    
    return results.map((result, index) => ({
      id: ids[index],
      success: result.status === 'fulfilled',
      data: result.status === 'fulfilled' ? result.value : null,
      error: result.status === 'rejected' ? result.reason.message : null
    }));
  }

  async updateMultipleAppointmentStatus(updates) {
    const promises = updates.map(({ id, status }) => 
      this.updateAppointmentStatus(id, status)
    );
    const results = await Promise.allSettled(promises);
    
    return results.map((result, index) => ({
      id: updates[index].id,
      success: result.status === 'fulfilled',
      data: result.status === 'fulfilled' ? result.value : null,
      error: result.status === 'rejected' ? result.reason.message : null
    }));
  }

  // ========================================================================
  // 🔧 DEBUG & TESTING UTILITIES
  // ========================================================================

  testUrls(testId = 'test123', testDoctorId = 'doc123', testPatientId = 'pat123') {
    console.log('🧪 Testing AppointmentService URLs:');
    console.table({
      'Base List': this.getAppointmentsUrl(),
      'By MongoDB ID': this.getAppointmentByIdUrl(testId),
      'By AppointmentId': this.getAppointmentByAppointmentIdUrl('APT-123'),
      'Check Despacho': this.getCheckDespachoAvailabilityUrl(),
      'By Product': this.getAppointmentsByProductUrl('prod123'),
      'By Despacho': this.getAppointmentsByDespachoUrl('desp123'),
      'Accept': this.getAcceptAppointmentUrl(testId),
      'Update Status': this.getUpdateStatusUrl(testId),
      'Check-in': this.getCheckInUrl(testId),
      'Start Consultation': this.getStartConsultationUrl(testId),
      'Complete': this.getCompleteConsultationUrl(testId),
      'Walk-In': this.getMarkAsWalkInUrl(testId),
      'Reschedule': this.getRescheduleAppointmentUrl(testId),
      'Cancel': this.getCancelAppointmentUrl(testId),
      'Confirm': this.getConfirmAppointmentUrl(testId),
      'No Show': this.getMarkAsNoShowUrl(testId),
      'Record Payment': this.getRecordPaymentUrl(testId),
      'Refund': this.getRefundPaymentUrl(testId),
      'Doctor All': this.getDoctorAppointmentsUrl(testDoctorId),
      'Doctor Today': this.getDoctorTodayAppointmentsUrl(testDoctorId),
      'Doctor Pending': this.getDoctorPendingAppointmentsUrl(testDoctorId),
      'Doctor Queue': this.getDoctorWaitingQueueUrl(testDoctorId),
      'Doctor Walk-in': this.getDoctorWalkInAppointmentsUrl(testDoctorId),
      'Doctor Cancelled': this.getDoctorCancelledAppointmentsUrl(testDoctorId),
      'Payment Stats': this.getDoctorPaymentStatsUrl(testDoctorId),
      'Patient': this.getPatientAppointmentsUrl(testPatientId)
    });
  }
}

// ✅ Export both default and named export
export default AppointmentService;

// Singleton instance
const appointmentServiceInstance = new AppointmentService();
export { appointmentServiceInstance };